import StatefulLink from "components/StatefulLink";
import { useRelativeModalPathsForDataRoutes } from "v2/hooks/useRelativeModalPathsForDataRoutes";

const DomainMultipliersText = () => {
  const modalPath = useRelativeModalPathsForDataRoutes("/domain-multiplier");

  return (
    <span className="text-xs text-gray-700">
      Guide to scraping costs:{" "}
      <StatefulLink
        to={modalPath}
        addLocationToState
        className="underline"
        hoverClassName="hover:text-primary-700"
      >
        Search for a domain
      </StatefulLink>
    </span>
  );
};

export default DomainMultipliersText;
